import { render, staticRenderFns } from "./inspector.vue?vue&type=template&id=8db0393a"
import script from "./inspector.vue?vue&type=script&lang=js"
export * from "./inspector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports